import { useEffect, useState } from 'react'
import { _systemAuthzCheckAuthz } from 'state/htj2-actions'

type HTJ2AuthorizationResult = {
	loading: boolean
	error: boolean
	authKeyWorks: boolean
	authorizationKeyType?: 'user' | 'manager'
}

export function useHTJ2Authorization(
	managerUUID: string | undefined,
	companyUUID: string | undefined,
	context?: 'user' | 'manager',
): HTJ2AuthorizationResult {
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(false)
	const [authKeyWorks, setAuthKeyWorks] = useState(false)
	const [authorizationKeyType, setAuthorizationKeyType] = useState<
		'user' | 'manager' | undefined
	>(undefined)

	useEffect(() => {
		let isMounted = true
		if (!managerUUID) {
			setLoading(false)
			setError(true)
			return
		}

		const checkAuth = async () => {
			setLoading(true)
			setError(false)
			setAuthKeyWorks(false)
			setAuthorizationKeyType(undefined)
			const result = await _systemAuthzCheckAuthz({ managerUUID, companyUUID })
			if (!isMounted) return
			if (result.success) {
				setAuthKeyWorks(result.data.authKeyWorks)
				if (context === undefined) {
					setAuthKeyWorks(result.data.authKeyWorks)
					setAuthorizationKeyType(result.data.authorizationKeyType!)
				} else if (context === 'user') {
					setAuthKeyWorks(
						result.data.authKeyWorks &&
							result.data.authorizationKeyType === 'user',
					)
					setAuthorizationKeyType('user')
				} else {
					setAuthKeyWorks(
						result.data.authKeyWorks &&
							result.data.authorizationKeyType === 'manager',
					)
					setAuthorizationKeyType('manager')
				}
			} else {
				if (isMounted) {
					setError(true)
				}
			}
			if (isMounted) {
				setLoading(false)
			}
		}

		checkAuth()
		return () => {
			isMounted = false
		}
	}, [managerUUID, companyUUID, context])

	return { loading, error, authKeyWorks, authorizationKeyType }
}
